import React from "react";
import "./style.scss";

const Page = ({ children }) => {
  return <div className="page-root">{children}</div>;
};

export default Page;
